import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, initFirebaseAuth } from '@helios/auth-firebase-web';
import { App } from './App';
import { getFirebaseConfig } from './auth/firebase-config';
import './index.css';

// Load the IBM Plex Sans webfont only for the clinical-blue theme
// (IntelisHealth). The env var is build-time, so Vite dead-code-eliminates this
// for other clients — they keep their system-font fallback and never bundle it.
if (import.meta.env.VITE_THEME_VARIANT === 'clinical-blue') {
  void import('@fontsource-variable/ibm-plex-sans');
}

// Initialize Firebase
initFirebaseAuth(getFirebaseConfig());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
